import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsEntriesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Entries</div>
          <div className="text">
            A changelog is simply a list of entries. The API allows you to fetch the list of entries
            associated with your&nbsp;changelog.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
